import { render } from "./CreateSystemService.vue?vue&type=template&id=a2da2696"
import script from "./CreateSystemService.vue?vue&type=script&lang=js"
export * from "./CreateSystemService.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kokleng/Documents/old_macbook/document/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__